<template>
  <div class="halloweenBox">
    <div class="alFitrBox langEn" :class="lang == 'ar' ? 'langAr':''">
      <div class="gift1"></div>
      <div class="gift2"></div>
    </div>
    
  </div>
</template>

<script>
export default {
  name: "halloween",
  data() {
    return {
      lang:'ar'
    };
  },
  mounted() {
      this.$completes.complete("getUserInfo");
      window.getUserInfo = this.getUserInfo;
      window['getUserInfo'] = (data) => {
          this.getUserInfo(data);
      }
  },
  methods: {
    getUserInfo(data) {
      this.userInfo = JSON.parse(data);
      let langs = this.userInfo.lang.substring(0, 2)
      if (langs == "ar") {
        this.$i18n.locale = "ar";
        this.lang = "ar";
      } else {
        this.$i18n.locale = "en";
        this.lang = "en";
      }
        document.title = 'Morocco Independence Day';
      
      document.querySelector("html").setAttribute("lang", this.$i18n.locale);
    }
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}
.alFitrBox{
  width: 640px;
}
.langEn{
  height: 2228px;
  padding-top: 1370px;
  box-sizing: border-box;
  background: url('../../assets/moroccoGun/enBg.png') no-repeat;
  background-size: 100% 100%;
}
.langAr{
  height: 2094px;
  padding-top: 1315px;
  background: url('../../assets/moroccoGun/arBg.png') no-repeat;
  background-size: 100% 100%;
}
.gift1{
  width: 128px;
  height: 128px;
  background: url('../../assets/moroccoGun/1.webp') no-repeat;
  background-size: 100% 100%;
  margin-left: 75px;
  box-sizing: border-box;
}
.gift2{
  width: 128px;
  height: 128px;
  background: url('../../assets/moroccoGun/2.webp') no-repeat;
  background-size: 100% 100%;
  margin-left: 75px;
  margin-top: 80px;
  box-sizing: border-box;
}
.langAr .gift1{
  margin-left: 438px;
}
.langAr .gift2{
  margin-top: 60px;
  margin-left: 438px;
}
</style>
